export enum MBMessageTypes {
  requestLDContext = "requestLDContext",
  sendLDContext = "sendLDContext",
  requestCompanySlug = "requestCompanySlug",
  sendCompanySlug = "sendCompanySlug",
  deleteDashboardSuccess = "deleteDashboardSuccess",
  logNoCompanySlugError = "logNoCompanySlugError",
  analyticsTrackEvent = "analyticsTrackEvent",
  modeChanged = "modeChanged",
  requestExportPDF = "requestExportPDF",
}
